import { Box, BoxProps, Flex, Image } from "@chakra-ui/react"
import { SupportedTokenName } from "@mezo/sdk"

import { getTokenIcon } from "#/shared/utils"

type DepositTokenProps = BoxProps & {
  token: SupportedTokenName
}

export default function DepositToken({ token, ...props }: DepositTokenProps) {
  return (
    <Box
      pos="absolute"
      top="1px"
      right="1px"
      h="78px"
      bg="primary.white.100"
      w="120px"
      pt="22px"
      pr="26px"
      zIndex={10}
      rounded="12px"
      {...props}
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        rounded="100%"
        bg="primary.black.5"
        pos="relative"
        ml="auto"
        p={1}
        w={9}
        h={9}
      >
        <Image src={getTokenIcon(token)} w="100%" h="100%" />
      </Flex>
    </Box>
  )
}
